import { Component, OnInit } from '@angular/core';
import { PageBaseComponent } from './page-base.component';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthService, DatasourceService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { PagerSettings } from "@progress/kendo-angular-listview";
import { environment } from '@environments/environment';
import { Location } from '@angular/common';


@Component({
  selector: 'customer-credits',
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-list.css'],
  styles: [`
    .k-listview {
      margin-bottom: 0px;
    }
  `],
  template: `

    <div class="wrapper-route">

      <customer-info [id]="id" (complete)="onComplete($event)"></customer-info>

      <div class="k-block" *ngIf="loading">
        <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
      </div>    

      <div class="wrapper" *ngIf="!loading">
        <kendo-tabstrip style="padding-top: 20px; padding-bottom: 120px;">
          <kendo-tabstrip-tab title="Pendientes ({{total_pending}})" [selected]="true">
            <ng-template kendoTabContent>

              <kendo-listview [kendoListViewBinding]="data_pending" [pageable]="pagerSettings" [pageSize]="pageSize" containerClass="k-d-flex k-flex-col k-flex-nowrap" *ngIf="!loading && data_pending.length">
                <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
                  <credit-detail-card class="card" [credit]="dataItem" [returnUrl]="dataItem.returnUrl" [borderTop]="!isFirst" ></credit-detail-card>
                </ng-template>
              </kendo-listview>

            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="Pagados ({{total_paid}})">
            <ng-template kendoTabContent>
              
              <kendo-listview [kendoListViewBinding]="data_paid" [pageable]="pagerSettings" [pageSize]="pageSize" containerClass="k-d-flex k-flex-col k-flex-nowrap" *ngIf="!loading && data_paid.length">
                <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
                  <credit-detail-card class="card" [credit]="dataItem" [returnUrl]="dataItem.returnUrl" [borderTop]="!isFirst" ></credit-detail-card>
                </ng-template>
              </kendo-listview>

            </ng-template>
          </kendo-tabstrip-tab>
        </kendo-tabstrip>
      </div>      

      <kendo-floatingactionbutton icon="arrow-left" themeColor="secondary" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'start', vertical: 'bottom' }" positionMode="fixed" (click)="goBack()" style="z-index: 1"></kendo-floatingactionbutton>

    </div>

  `
})
export class CustomerCreditsComponent extends PageBaseComponent implements OnInit {

  public id: number = 0;

  public customer: any = null;

  public data_pending: any[];
  public data_paid: any[];

  public total_pending: number;
  public total_paid: number;

  public pagerSettings: PagerSettings = {
    previousNext: true,
    pageSizeValues: false,
    buttonCount: 9,
  };

  public pageSize = 10;

  public defaultImage: string = environment.assets.DEFAULT_VEHICLE;

  protected search: string = '';

  protected searchColumns: any[] = [
    'cost',    
    'crane_name',
    'entry_date',
    'output_date',
    'person_operator_name',
    'place'
  ];

  public returnUrl: string = 'credits';


  constructor(public authService: AuthService, protected router: Router, protected route: ActivatedRoute, protected service : DatasourceService, private http: HttpClient, private location: Location) { 

    super(authService, router)
    let id = this.route.snapshot.paramMap.get('id');
    this.id = (id != null) ? parseInt(id): 0;

    let state = location.getState() as {returnUrl: string};
    if(state.returnUrl != null)
      this.returnUrl = state.returnUrl;

  }

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.take = 0;
    s.sort = [      
      {field: 'expiration_date', dir: 'asc'}
    ];
    s.filter = {
      logic: "and",
      filters: [
        {
          field: 'id_customer',
          operator: 'eq',
          value: this.id
        }
      ]
    }

    if(this.search != ''){      
      s.filter.filters.push(
        {
          logic: "or",
          filters: this.searchColumns.map(item => {
            return {
              field: item,
              operator: 'contains',
              value: this.search
            }
          })
        }
      )
    }

    return s;

  }

  ngOnInit() { 
    
    this.update();
    
  }

  public onSearchChange(value: any): void {

    this.search = value;

    this.update();    

  }

  public update() {

    this.loading = true;

    this.state = this.getInitialState();

    this.service.search('credits', this.state)
      .subscribe(
        (result: any) => {
          console.log(result);
          this.data_pending = result.data
            .filter((v) => v.status_payment !== 'PAGADO' )
            .map(function(d, i){
              d.returnUrl = 'customer_credits/' + d.id_customer
              return d;
            });  
            
          this.total_pending = this.data_pending.length;
          
          this.data_paid = result.data
            .filter((v) => v.status_payment === 'PAGADO' )
            .map(function(d, i){
              d.status_credit_color = d.status_payment_color;
              d.returnUrl = 'customer_credits/' + d.id_customer
              return d;
            }); 

          this.total_paid = this.data_paid.length;

          this.loading = false;
        },
        (error: any) => {
            console.log(error)
            // this.loading = false;
        });

  }

  public goBack() {

    this.router.navigate([`/${this.returnUrl}`]);

  }

  // public goAddService() {

  //   this.router.navigate(['/service_new']);

  // }

  public onComplete(event: any) {

    this.customer = event.dataItem;
    // this.form.patchValue({
    //   cost_crane: this.vehicle.cost_crane
    // });

  }

}